<template>
    <div class="tags">
        <el-tag v-for="(item, index) in tags" :key="item.path" :closable="item.name !== 'home'"
            :effect="$route.name === item.name ? 'dark' : 'light'" @click="changeMenu(item)"
            @close="handleClose(item, index)" size="small">
            {{ item.label }}
        </el-tag>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
    name: 'CommonTag',
    data() {
        return {}
    },
    computed: {
        ...mapState({
            tags: state => state.tab.tabsList
        })
    },
    methods: {
        //调用函数
        ...mapMutations(['closeTag']),
        changeMenu(item) {
            // this.$store.commit('closeTab', item) 通过对象的方式进行跳转
            this.$router.push({ name: item.name })
        },
        //点击删除的逻辑
        handleClose(item, index) {
            //调用store中的mutation方法
            this.closeTag(item)
            const length = this.tags.length
            console.log(9023901);
            console.log(length);
            //删除之后的跳转逻辑
            if (item.name !== this.$route.name) {
                return
            }
            if (index === length) {
                this.$router.push({
                    name: this.tags[index - 1].name
                })
            } else {
                this.$router.push({
                    name: this.tags[index].name
                })
            }

        }
    }
}

</script>
<style lang="less" scoped>
.tags {
    padding: 20px;

    .el-tag {
        margin-right: 15px;
        cursor: pointer;
    }
}
</style>